import React, { useEffect, useState } from "react";
import plusIcon from "../../../assets/images/Svg/plusIcon.svg";
import AddAllergy from "./AddAllergy";
import { Modal } from "antd";
import MedicalService from "../../../Services/MedicalService";
import dayjs from "dayjs";
import { FiPlus } from "react-icons/fi";

function Allergy(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [patientAlleryData, setPatientAlleryData] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    PatientAllergies();
  }, [props.selectedPatient.patientId]);

  const handleAllergyClick = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    PatientAllergies();
  };

  const PatientAllergies = () => {
    let payload = {
      patientCode: props.selectedPatient.patientId,
      status: 1,
    };
    MedicalService.PatientAllergiesList(payload)
      .then((result) => {
        setPatientAlleryData(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[15%] bg-secondaryColor flex items-center justify-between rounded-lg p-2">
          <h1 className="font-bold text-normal  text-white ">
            Allergy Details
          </h1>
          <img
            src={plusIcon}
            onClick={() => handleAllergyClick()}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div
          className="body h-[70%]  overflow-y-auto items-center bg-brand-lightBg"
          id="unquie-scroll"
        >
          {patientAlleryData.length > 0 ? (
            patientAlleryData.map((user, i) => (
              <div key={i} className="mt-3 flex flex-col gap-2">
                {user.drugAllergy && (
                  <div className="text-gray-500  font-light text-sm">
                    <span className="font-medium text-black relative list-dec-before pl-3">
                      Drug Allergies :
                    </span>
                    <span className="font-medium text-gray-500">
                      {user.drugAllergy}
                    </span>
                  </div>
                )}
                {user.foodAllergy && (
                  <div className="text-gray-500  font-light text-sm">
                    <span className="font-medium text-black relative list-dec-before pl-3">
                      Food Allergies :
                    </span>
                    <span className="font-medium text-gray-500">
                      {user.foodAllergy}
                    </span>
                  </div>
                )}
                {user.chemicalAllergy && (
                  <div className="text-gray-500 text-black  font-light text-sm">
                    <span className="font-medium text-black relative list-dec-before pl-3">
                      Chemical Allergies :
                    </span>
                    <span className="font-medium text-gray-500">
                      {user.chemicalAllergy}
                    </span>
                  </div>
                )}
                {user.otherAllergy && (
                  <div className="text-gray-500 text-black  font-light text-sm">
                    <span className="font-medium text-black relative list-dec-before pl-3">
                      Other Allergies : 
                    </span>
                    <span className="font-medium text-gray-500">
                      {user.otherAllergy}
                    </span>
                  </div>
                )}
                <div className="flex ml-3 mt-1">
                  <div className="text-gray-400  font-medium text-sm">
                    Check up date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </div>
                </div>
                {i !== patientAlleryData.length - 1 && (
                  <hr className="my-4 border-gray-300" />
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
        <div className="footer h-[10%]  bg-secondaryColor rounded-md"></div>
      </div> */}
      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Allergy Details</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={() => handleAllergyClick()}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-44 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {patientAlleryData.length > 0 ? (
            patientAlleryData.map((user, i) => (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#F7FFFE] border border-[#95F0DF] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Drug Allergies:</strong> {user.drugAllergy}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
                {hoveredIndex === i && (
                  <div
                    className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                    style={{ top: "200px", left: "300px" }}
                  >
                    {" "}
                    {user.drugAllergy && (
                      <p>
                        <strong>Drug Allergies:</strong> {user.drugAllergy}
                      </p>
                    )}
                    {user.foodAllergy && (
                      <p>
                        <strong>Food Allergies:</strong> {user.foodAllergy}
                      </p>
                    )}
                    {user.chemicalAllergy && (
                      <p>
                        <strong>Chemical Allergies:</strong>{" "}
                        {user.chemicalAllergy}
                      </p>
                    )}
                    {user.otherAllergy && (
                      <p>
                        <strong>Other Allergies:</strong> {user.otherAllergy}
                      </p>
                    )}
                    <p>
                      <strong>Onset date:</strong>{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>

      {isModalVisible && (
        <Modal
          title={
            <span className="text-base font-semibold font-sans">
              Add Allergy
            </span>
          }
          visible={isModalVisible}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={500}
          maskClosable={false}
        >
          <AddAllergy
            selectedPatient={props.selectedPatient}
            onClose={() => handleCloseModal()}
          />
        </Modal>
      )}
    </div>
  );
}

export default Allergy;
